module.exports = __webpack_public_path__ + "static/media/blackheart.44d9bc3a.svg";